import { SidebarHeader } from '@/components/ui/sidebar'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
import { appLink } from '@app/config/appLink'
import { SidebarAtom } from '@app/state/layoutAtom'
import { AnimatePresence, motion } from 'framer-motion'
import { useAtomValue } from 'jotai'
import { useNavigate } from 'react-router-dom'

const logoVariants = {
  initial: { opacity: 0, scale: 0.8 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.8 },
}

export const SidebarLogo = () => {
  const navigate = useNavigate()
  const isOpen = useAtomValue(SidebarAtom)

  const UILogo = `${PUBLIC_ASSETS_BASE_URL}/images/shared/new_RexLogoSimple.svg`
  const UIFull = `${PUBLIC_ASSETS_BASE_URL}/images/shared/new_RexLogoFull.svg`

  return (
    <SidebarHeader className="px-2 py-3">
      <motion.button
        type="button"
        onClick={() => navigate(appLink.homepage.path)}
        aria-label="Go home"
        className="flex h-12 w-full items-center overflow-hidden rounded-md px-2 transition hover:bg-white/10 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:px-0 justify-center"
        transition={{ duration: 0.2, ease: 'easeOut' }}
      >
        <AnimatePresence mode="wait" initial={false}>
          {isOpen ? (
            <motion.img
              key="full"
              src={UIFull}
              alt="Urban Intelligence full logo"
              className="h-9 w-auto object-contain"
              variants={logoVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.25, ease: 'easeOut' }}
            />
          ) : (
            <motion.img
              key="simple"
              src={UILogo}
              alt="Urban Intelligence simple logo"
              className="size-8 object-contain"
              variants={logoVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.25, ease: 'easeOut' }}
            />
          )}
        </AnimatePresence>
      </motion.button>
    </SidebarHeader>
  )
}
